import { EnvironmentConfigurations } from '@livefree/runtime';

export const ShellConfig = EnvironmentConfigurations.hydrate({
  development: {
    host: 'https://localhost:9002',
    api: {
      host: 'https://localhost:7104',
    },
    auth: {
      //host: 'https://localhost:44354', // When using development login
      host: 'https://lf-login-staging.azurewebsites.net', // When using staging login
      clientId: 'e95eced797414c64bfe916d89d4adf35',
      //scopes: 'openid profile email phone IdentityServerApi',
      scopes:
        'openid profile email phone IdentityServerApi scope://ticketing-api/default scope://transactions-api/default scope://cellular-api/default scope://accounts-api/default scope://notifications-api/default scope://scheduling-api/default scope://reminders-api/default scope://sales-api/default scope://devices-api/default scope://products-api/default scope://inventory-api/default scope://billing-api/default scope://collections-api/default',
      //applicationKey: 'EB235D280C574A70A4A26E1008877384', // When using development login
      applicationKey: '561c3d0d43be48629978fa15e15dfcb6', // When using staging login
    },
  },
  staging: {
    host: 'https://lf-artemis-staging.azurewebsites.net',
    api: {
      host: 'https://lf-artemis-api-staging.azurewebsites.net',
    },
    auth: {
      host: 'https://lf-login-staging.azurewebsites.net',
      clientId: 'e95eced797414c64bfe916d89d4adf35',
      scopes:
        'openid profile email phone IdentityServerApi scope://ticketing-api/default scope://transactions-api/default scope://cellular-api/default scope://accounts-api/default scope://notifications-api/default scope://scheduling-api/default scope://reminders-api/default scope://sales-api/default scope://devices-api/default scope://products-api/default scope://inventory-api/default scope://billing-api/default',
      applicationKey: '561c3d0d43be48629978fa15e15dfcb6',
    },
  },
  production: {
    host: [
      'https://artemis.lifebeacon.com',
      'https://app.alert1.com',
      'https://app.lifebeacon.com',
    ],
    api: {
      host: 'https://artemis.lfapi.net',
    },
    auth: {
      host: 'https://login.lifebeacon.com',
      clientId: 'e95eced797414c64bfe916d89d4adf35',
      scopes:
        'openid profile email phone IdentityServerApi scope://ticketing-api/default scope://transactions-api/default scope://cellular-api/default scope://accounts-api/default scope://notifications-api/default scope://scheduling-api/default scope://reminders-api/default scope://sales-api/default scope://devices-api/default scope://products-api/default scope://inventory-api/default scope://billing-api/default',
      applicationKey: '999446fe0e474416943004297252195a',
    },
  },
  extended: {
    preferences: {
      rootPath: '/',
    },
    googleMapsKey: 'AIzaSyBk67alAd9TWqehZxRSYXQzv2S_71olvdo',
  },
});
